import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["bgColor", "className", "style", "children", "gutter", "flex", "wrap", "justify", "align", "jss"];
import React from 'react';
import cn from 'classnames';
import memoize from '@guestyci/memoize';
import { firstLetterUppercase as capitalize } from "../../utils/commonUtility";
import createStyles from "../../createStyles";
import styles from "../styles";
import { isNumber } from "../../utils";
export var generateGutter = memoize(function (gutter, spacer) {
  if (!gutter) {
    return undefined;
  }

  if (isNumber(gutter)) {
    return spacer(gutter);
  }

  return gutter.split(' ').reduce(function (padding, item) {
    return "".concat(padding, " ").concat(spacer(item), "px");
  }, '').trim();
});
export var useStyles = createStyles(function (theme) {
  return _extends({
    root: {
      backgroundColor: function backgroundColor(_ref) {
        var bgColor = _ref.bgColor;
        return bgColor;
      }
    },
    gutter: {
      padding: function padding(_ref2) {
        var gutter = _ref2.gutter;
        return generateGutter(gutter, theme.spacer);
      }
    },
    displayFlex: {
      display: 'flex',
      width: '100%'
    }
  }, styles);
}, {
  name: 'Section'
});
var Section = /*#__PURE__*/React.forwardRef(function Section(_ref3, ref) {
  var _cn;

  var _ref3$bgColor = _ref3.bgColor,
      bgColor = _ref3$bgColor === void 0 ? 'initial' : _ref3$bgColor,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      _ref3$style = _ref3.style,
      style = _ref3$style === void 0 ? {} : _ref3$style,
      _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? null : _ref3$children,
      _ref3$gutter = _ref3.gutter,
      gutter = _ref3$gutter === void 0 ? 0 : _ref3$gutter,
      _ref3$flex = _ref3.flex,
      flex = _ref3$flex === void 0 ? true : _ref3$flex,
      _ref3$wrap = _ref3.wrap,
      wrap = _ref3$wrap === void 0 ? true : _ref3$wrap,
      _ref3$justify = _ref3.justify,
      justify = _ref3$justify === void 0 ? 'start' : _ref3$justify,
      _ref3$align = _ref3.align,
      align = _ref3$align === void 0 ? 'stretch' : _ref3$align,
      jss = _ref3.jss,
      props = _objectWithoutProperties(_ref3, _excluded);

  var classes = useStyles({
    bgColor: bgColor,
    gutter: gutter,
    jss: jss
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: ref,
    className: cn(classes.root, (_cn = {}, _defineProperty(_cn, classes.gutter, gutter), _defineProperty(_cn, classes.flexWrap, wrap), _defineProperty(_cn, classes.displayFlex, flex), _defineProperty(_cn, classes["justify".concat(capitalize(justify))], justify !== 'start'), _defineProperty(_cn, classes["alignItems".concat(capitalize(align))], align !== 'stretch'), _cn), className),
    style: style
  }), children);
}); // Hack for withInfo plugin

Section.displayName = 'Section';
export default Section;